<template>
    <div>
        <v-card>
            <div>
                <v-toolbar flat color="white">
                    <v-toolbar-title>{{ header }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-divider></v-divider>
            </div>
            <div>
                <v-container fluid>
                    <v-layout row>
                        <v-flex xs12 md6>
                            <v-text-field
                                    label="Name"
                                    light
                                    name="name"
                                    :autofocus="true"
                                    v-model="model.name"
                                    placeholder="Please enter playlist name "
                                    v-validate="'required'"
                                    :success="!errors.first('name')"
                                    :error-messages="errors.first('name')"
                            ></v-text-field>
                            <v-btn color="primary" dark depressed @click="submitCategory" >Submit</v-btn>
                        </v-flex>

                    </v-layout>
                </v-container>
            </div>
        </v-card>
    </div>
</template>

<script>
  import Vue from "vue";
  import Axios from "axios";

  export default {
    data() {
      return {
        url: "/api/v1/categories",
        progress: 0,
        thumbUrl: "",
        model: {
          name: "",

        },
        header: "Add Playlist",
        categoryRule: [ v => !!v || 'Playlist is required' ],
        submitting: false
      };
    },
    methods: {

      async submitCategory(){
        await this.$validator.validateAll();
        if(this.errors.any()){
          return;
        }
        try{
          this.submitting = true;
          await Axios.post(this.url, {"data": this.model}).catch(function (error) {
            console.log(">>>>", error)
          });

          this.submitting = false;
          this.$router.push('/categories');
        }catch (e){
          this.submitting= false
        }
      }
    },
    mounted() {
      window.onbeforeunload = () => {
        return "Hey, are you want sure want to unload the page? This may cause a loss of unsaved information.";
      };
    }
  };
</script>

<style>

    .fileContainer [type="file"] {
        cursor: inherit;
        display: block;
        filter: alpha(opacity=0);
        min-height: 100%;
        min-width: 100%;
        opacity: 0;
        position: absolute;
        right: 0;
        text-align: right;
        top: 0;
    }
    .ve-select span {
        font-size: 14px;
    }

</style>


// WEBPACK FOOTER //
// resources/assets/js/pages/categories/create.vue